import { gql } from '@apollo/client'

export const DocumentQuery = gql`
  query Document($companyId: ID!, $filters: DocumentFilters) {
    documents(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        reference
        dateIssued
        dateDue
        subject {
          ... on AssetType { id name }
          ... on Asset { id name }
          ... on Package { id name }
          ... on Event { id description }
        }
        url
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
